// Constantes partilhadas pela aplicação.
// Extraídas de App.js (que tinha tudo no mesmo ficheiro) para serem
// reutilizáveis e fáceis de manter num só sítio.

export const ZONAS = [
  "Coimbra Centro", "Coimbra Norte", "Coimbra Sul", "Condeixa-a-Nova",
  "Figueira da Foz", "Lousã", "Montemor-o-Velho", "Penacova", "Soure", "Outra"
];

export const TIPOS_IMOVEL = [
  "Apartamento", "Moradia", "Terreno", "Escritório / Comercial",
  "Loja", "Armazém / Industrial", "Prédio"
];

export const FONTES = [
  "Base de Dados Antiga", "Campanha Digital", "Chamada", "CIP's", "Cliente Antigo",
  "Email", "Escala", "FSBO", "Placa", "Portais (Idealista, Imovirtual...)",
  "Posicionamento", "Prospeção", "Recomendação de Cliente", "Referência Colega",
  "Redes Sociais", "Site Remax", "Outro"
];

export const CONSULTORES_EQUIPA = [
  "Ana Lucas", "Carlos Matos", "Cátia Ribeiro", "Filipa Pereira", "Guilherme Nunes",
  "Hernâni Ferreira", "Paulo Branco", "Rodrigo Francisco", "Sandra Ferreira",
  "Sérgio Marques", "Silvia Bento", "Sónia Henriques", "Tony Silva", "Vitor Melo",
  "Zita Valente"
];

export const TIPOS_CLIENTE = ["Comprador", "Vendedor", "Senhorio", "Arrendatário", "Investidor"];

export const TIPOLOGIAS = ["T0", "T1", "T2", "T3", "T4", "T5+", "N/D"];

export const FINANCIAMENTO_OPTS = [
  "Não – Capitais Próprios",
  "Sim – Quer Ajuda MaxFinance White",
  "Sim – Próprio Banco",
  "Outro intermediário",
  "Por definir"
];

export const VALIDACAO_OPTS = [
  "✅ Lead Válida",
  "🔍 Lead em Validação",
  "❌ Lead Não Válida"
];

export const TEMPERATURA_OPTS = [
  "🔴 Muito Quente (imediata)",
  "🟠 Quente (1 a 3 meses)",
  "🟡 Morna (3 a 6 meses)",
  "🔵 Fria (+1 ano)",
  "⚫ Desinteressada"
];

export const CANAL_SEGUIMENTO = [
  "Chamada", "Email", "Reunião presencial", "WhatsApp", "Início de visitas"
];

export const PIPELINE_STAGES = [
  { id: "novo", label: "Novo Contacto", color: "#6366f1", bg: "#eef2ff" },
  { id: "qualificado", label: "Qualificado", color: "#f59e0b", bg: "#fffbeb" },
  { id: "seguimento", label: "Em Seguimento", color: "#3b82f6", bg: "#eff6ff" },
  { id: "promocao", label: "Em Seguimento — Promoção", color: "#0284c7", bg: "#e0f2fe" },
  { id: "visita", label: "Visita Agendada", color: "#8b5cf6", bg: "#f5f3ff" },
  { id: "proposta", label: "Sob Proposta", color: "#f97316", bg: "#fff7ed" },
  { id: "financiamento", label: "Financiamento", color: "#06b6d4", bg: "#ecfeff" },
  { id: "cpcv_pedido", label: "CPCV Pedido", color: "#7c3aed", bg: "#faf5ff" },
  { id: "cpcv", label: "CPCV Assinado", color: "#6d28d9", bg: "#ede9fe" },
  { id: "escritura_agendada", label: "Escritura Agendada", color: "#059669", bg: "#d1fae5" },
  { id: "escriturado", label: "Escriturado", color: "#10b981", bg: "#ecfdf5" },
  { id: "vendido", label: "Vendido", color: "#16a34a", bg: "#f0fdf4" },
  { id: "arrendado", label: "Arrendado", color: "#0e7490", bg: "#cffafe" },
  { id: "fechado", label: "Negócio Fechado", color: "#10b981", bg: "#ecfdf5" },
  { id: "perdido", label: "Lead Perdida", color: "#ef4444", bg: "#fef2f2" },
  { id: "pos_venda", label: "Seguimento Pós-Venda", color: "#ec4899", bg: "#fdf2f8" },
];
